export const contactsData = {
    link1: 'آکادمی علوم زیبایی',
    link2: 'مراقبت های پوست و مو',
    link3:'آرایشی و بهداشتی ',
    link4:'لاغری و تناسب اندام',
    link5:'مشاوره و خدمات تخصصی',
    link6:' تماس با ما',
    

    sheetAPI: ''
}